export default __webpack_public_path__ + "58102e892e266c2a54f6d01cded4697a.png";